<template>
    <div>
        <FullCalendar :options="calendarOptions"/>
    </div>
</template>

<script>
    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import listPlugin from '@fullcalendar/list'
    import interactionPlugin from '@fullcalendar/interaction';
    import bootstrapPlugin from '@fullcalendar/bootstrap';
    import swalMessages from "../mixins/swal-messages";

    export default {
        name: "CalendarEvents",
        props: {
            input_events: Array
        },
        mixins: [ swalMessages ],
        components: {
            FullCalendar,
        },
        data() {
            return {
                calendarOptions: {
                    plugins: [ dayGridPlugin, interactionPlugin, listPlugin, bootstrapPlugin ],
                    initialView: 'dayGridMonth',
                    themeSystem: 'bootstrap',
                    headerToolbar: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'dayGridMonth,listMonth'
                    },
                    events: this.input_events.map(event => (
                        {
                            ...event,
                            start: event.starts_at,
                            end: event.ends_at,
                            title: event.name,
                            url: `${event.id}`,
                            display: 'block',
                            color: this.color(event.product_id),
                            textColor: '#000000',
                        }
                    )),
                    eventMouseover: function( event, jsEvent, view ) {
                        console.log('work')
                    },
                    // eventClick: (args) => {
                    //     const { start, end, title } = args.event;
                    //
                    //     const html = `
                    //         <strong>Starts: ${start.toLocaleString()}</strong><br>
                    //         <strong>Ends: ${end.toLocaleString()}</strong>
                    //     `
                    //
                    //     this.showInfoMessage(title, '',  html);
                    //
                    //     this.calendar = args.event;
                    //     this.date = { start, end, title };
                    // }
                },
                calendar: null,
                date: null
            }
        },
        methods: {
            color(number) {
                return `hsl(${number * 137.508},50%,75%)`
            }
        }
    }
</script>

<style lang="less">
    .calendar-page {
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: 50% 100%;
        padding-bottom: 6.25rem;

        .calendar-holder {
            border-radius: 30px;
            background-color: rgb(255, 255, 255);
            box-shadow: 13.946px 29.908px 49px 0px rgba(0, 0, 0, 0.33);
            margin: 3rem auto 0;
            max-width: 62.5rem;
            overflow: hidden;
        }
    }

    #calendar {
        padding: 1.25rem;
    }

    .fc-header-toolbar {
        margin: 1rem 2rem 1.5rem !important;
        flex-wrap: wrap !important;
    }

    .fc-toolbar-chunk {
        margin-top: 10px !important;
    };

    .fc button {
        box-sizing: border-box;
        margin: 0;
        height: 2.6em !important;
        cursor: pointer;
    }
    .fc-prev-button, .fc-next-button {
        min-width: 10rem !important;
        background: #20c997 !important;
    }
    .fc-prev-button {
        margin-right: 1rem !important;
    }

    .fc-event {
        background: #20c997;
        border: #20c997;
        color: #000000;
    }
    .fc-event:hover {
        cursor: pointer;
    }

    .fc-event-time {
        display: none !important;
    }

    .fc-today {
        background: #fef1c9;
    }

    .fc-event-title {
        font-weight: bold !important;
    }

    .fc-month-button, .fc-listMonth-button {
        padding: 0 1.25rem !important;
    }

    .fc-daygrid-day-number {
        padding-right: 1rem !important;
    }

    .fc-event-dot {
        background: #f7c44e;
    }

    @media (max-width: 1199.98px) {}
    @media (max-width: 991.98px) {}
    @media (max-width: 767.98px) {}
    @media (max-width: 575.98px) {
        .fc-header-toolbar {
            margin-left: 0.5rem !important;
            margin-right: 0.5rem !important;
        }
        .btn-group {
            display: flex !important;

            button {
                font-size: 0.6rem !important;
                min-width: 0 !important;
            }
        }

        .fc-today-button {
            display: none !important;
        }
        .fc-prev-button {
            margin-right: 0 !important;
        }
        .fc-toolbar-title {
            font-size: 0.69em !important;
            margin: 0 !important;
        }
        .fc-dayGridMonth-button {
            padding-top: 4px !important;
        }
        .fc-listMonth-button {
            padding-top: 2px !important;
        }

        .fc-dayGridMonth-button, .fc-listMonth-button {
            margin: 0 !important;
            padding: 0 !important;
            width: 55px !important;
        }
    }
</style>
